import { FC } from "react";
import { Theme } from "@radix-ui/themes";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useParams } from "react-router-dom";
import { Loader } from "@/components";
import useSetClient from "@/hooks/useSetClient";
import EventsOverview from "@/features/events/components/overview/EventsOverview.fetcher";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

const EventsPage: FC = (): JSX.Element => {
  const { slug } = useParams();
  useDocumentTitle("Events");

  const { zoneItem, loadingZone: loading } = useSetClient(slug);

  const theme =
    themeMap[zoneItem?.theme.toUpperCase()] ||
    themeMap[brand.brandTheme.toUpperCase()] ||
    "violet";
  const radius = themeRadiusMap[zoneItem?.theme.toUpperCase()] || "none";

  if (loading) {
    return <Loader />;
  }

  if (slug) {
    return (
      <Theme appearance="dark" accentColor={theme} radius={radius}>
        <EventsOverview zoneId={slug} />
      </Theme>
    );
  }

  return <EventsOverview />;
};

export default EventsPage;
